import React, { Component } from 'react';
import Loading from 'react-fullscreen-loading';
class Loader extends Component {
    render() {
        return (
            <div>
                <Loading loading loaderColor="#d63384" />
            </div>
        );
    }
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/loader/index.js